import { render, staticRenderFns } from "./CustomerCheckPhone.vue?vue&type=template&id=0a9b53df&scoped=true&"
import script from "./CustomerCheckPhone.vue?vue&type=script&lang=ts&"
export * from "./CustomerCheckPhone.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerCheckPhone.vue?vue&type=style&index=0&id=0a9b53df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b53df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VRow,VTextField})
